module.exports = "/_next/static/media/9c669f6b1b5925163215ed93fe6663d4.svg";